import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import findReadWriteRecipient from 'owa-readwrite-recipient-well/lib/actions/findReadWriteRecipient';
import getReadWriteRecipientViewState from 'owa-recipient-common/lib/utils/getReadWriteRecipientViewState';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import isValidEmailAddress from 'owa-recipient-common/lib/utils/isValidEmailAddress';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import convertPersonaToRecipientViewState from '../utils/convertPersonaToRecipientViewState';

export default async function forceAddRecipientFromQueryString(
    getViewState: () => FindControlViewState,
    addRecipients: (recipientsToAdd: ReadWriteRecipientViewState[]) => void
) {
    const queryString = getViewState().queryString;

    // Only force add if the query string isn't empty
    if (!isNullOrWhiteSpace(queryString)) {
        // Find recipients based on the query string
        await findReadWriteRecipient(getViewState(), queryString, true /*searchDirectory*/);

        let recipientToAdd: ReadWriteRecipientViewState;

        if (getViewState().findResultSet.length == 1) {
            // If we only found one result, use it
            const singletonFindResult = getViewState().findResultSet[0];
            recipientToAdd = convertPersonaToRecipientViewState([singletonFindResult])[0];
        } else {
            // Otherwise, just create a recipient from the query string. If the query string
            // is a full SMTP, this will be a valid recipient. If not, it will be invalid.
            recipientToAdd = getReadWriteRecipientViewState(
                null /* newPersona */,
                isValidEmailAddress(queryString),
                queryString
            );
        }

        // Add the recipient
        addRecipients([recipientToAdd]);
    }
}
